module.exports = __webpack_public_path__ + "static/camtest.d-8b0f3927d556d69447a5a4ff66d22dd3.webp";